// D:\CRM_FOLATRAVEL\frontend\src\index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // <-- 1. IMPORT BROWSER ROUTER
import App from './App';
import axios from 'axios';
import './index.css';

// Đặt URL cơ sở cho API (từ bước trước)
axios.defaults.baseURL = 'http://127.0.0.1:8000/api';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 2. BỌC TOÀN BỘ <App /> BẰNG <BrowserRouter> */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);